import productImg from "../../../assets/img/product-6-and-bonus-black.png";
import productImgWebp from "../../../assets/img/product-6-and-bonus-black.webp";
import bonusImg from "../../../assets/img/bonus-3.png";
import bonusImgWebp from "../../../assets/img/bonus-3.webp";

const Gift3 = () => {

    return (
        <section id="gift3">
            <div className="container-fluid gg-bg-solid-green-light py-4">
                <div className="row align-items-center justify-content-center text-center">
                    <div className="col-md-8 col-11">
                        <h5 className="fw-light mb-4">But since you’re one of the very few who received this special one-time upgrade offer…</h5>
                        <h3 className="mb-0"><b>We wanted to do something we’ve never done before.</b></h3>
                        <h3 className="mb-4"><b>Something just for you.</b></h3>
                    </div>
                </div>
                <div className="row justify-content-center align-content-center mb-4">
                    <div className="col-xxl-8 col-lg-10 col-11 py-4 px-xxl-4 px-3 gg-bg-solid-green gg-border-radius text-white text-center">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-md-4 col-12 text-center">
                                <picture>
                                    <source srcSet={bonusImgWebp} type="image/webp" />
                                    <img className="img-fluid rounded gg-img-gift" alt="Dr. Hart" src={bonusImg} loading="lazy" />
                                </picture>
                            </div>
                            <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                                <h3>BONUS 3. The GlucoGen<sup>17</sup> Naturals <span className="gg-yellow">Progress Tracker Calendar</span> (Value: $20)</h3>
                                <p>A beautifully designed one-page printable that helps you track every step of your reset journey. Mark your wins. Stay consistent. Watch your progress come to life. You deserve to see how far you’ve come! </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center justify-content-center text-center mb-3">
                    <div className="col-md-8 col-11">
                        <h5 className="fw-bold mb-3">⚠️ This 3rd bonus isn’t available anywhere else.</h5>
                        <h5 className="mb-4"> It’s the first time we’re offering it - and the last.<br /> Only those who upgrade right now will get it.</h5>
                        <h5 className="mb-4 fw-bold">Once this page closes, it’s gone for good.</h5>
                        <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu6u&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-decoration-none btn gg-button-buy-yellow gg-bigger-button px-3 mb-4 mt-1 fw-bold gtm-nav-btn" data-gtm-label="GlucoGen Upsell 6 - Bonus 3 - Go To Offer">Yes! Upgrade My Order Now</a>
                        <h5>Give me the <b>6-month supply</b>, all <b>3 bonuses</b>, and <b>free shipping</b> for just <s>$1182</s> <b>$216</b> while it’s still available.</h5>
                    </div>
                </div>
                <div className="row align-items-center justify-content-center text-center">
                    <div className="col-12">
                        <picture>
                            <source srcSet={productImgWebp} type="image/webp" />
                            <img className="img-fluid" src={productImg} loading="lazy" />
                        </picture>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Gift3;